export default __webpack_public_path__ + "9dfebe3f8f20144bafc18a133b15d32b.png";